import { ErrorDialog } from "@codat/orchard-ui";
import { AxiosError } from "axios";
import React from "react";
import { ApiError } from "shared";

interface ErrorProps {
  error: AxiosError;
  activity: string;
}

export const AxiosErrorDialog: React.FC<ErrorProps> = ({ error, activity }) => {
  const codatError = error.response?.data as ApiError;
  const errorMessage = codatError?.error
    ? `An error occurred ${activity}: ${codatError?.error}`
    : `An unexpected error occurred ${activity}`;

  return (
    <ErrorDialog
      statusCode={codatError?.statusCode ?? error.response?.status ?? 500}
      correlationId={codatError?.correlationId}
      message={errorMessage}
    />
  );
};
